import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DealRow from "./deal-row.vue";
import { mapActions, mapState } from "vuex";
import { SYNC_WITH_FILOGIX, LOAD_CLIENT_DATA, LOAD_APPLICATION_DATA } from "../../../../../store/application-actions";
import { UPDATE_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { showToast } from "../../../../../../../../../../../shared/utils/constants";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DealList",
  components: {
    DealRow
  },
  props: {
    filogixSubmissions: {
      type: Array,
      default: () => []
    },
    lenders: {
      type: Array,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filogixSubmissionId: null,
      destroyed: false,
      syncProgress: {
        // sync progress by filogixSubmissionId
        // 123: { loading: false, loadingSucceeded: true }
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("SettingsStore", {
    savedFilogixDetails(state) {
      return state.filogixDetails;
    }
  })), mapState("StatusPageStore", ["externalServicesIncidents"])), {}, {
    hasIncident() {
      const incident = this.externalServicesIncidents.byId["expert"] || {};
      return !isEmpty(incident);
    },
    validFilogixDetails() {
      return this.savedFilogixDetails && this.savedFilogixDetails.firmCode && this.savedFilogixDetails.expertLoginId;
    }
  }),
  beforeDestroy() {
    this.destroyed = true;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SYNC_WITH_FILOGIX, LOAD_CLIENT_DATA, LOAD_APPLICATION_DATA])), mapActions("SettingsStore", [UPDATE_FILOGIX_DETAILS])), {}, {
    async handleSyncWithFilogix(filogixSubmissionId) {
      try {
        this.$set(this.syncProgress, filogixSubmissionId, {
          loading: true,
          loadingSucceeded: true
        });
        await this.SYNC_WITH_FILOGIX({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          filogixSubmissionId
        });
        await this.LOAD_APPLICATION_DATA({
          clientUsername: this.clientUsername,
          agentUsername: this.agentUsername,
          applicationId: this.applicationId
        });
        this.$emit("refresh");
        showToast("success", "applicationSyncedWithFilogixSuccessfully");
        this.$set(this.syncProgress, filogixSubmissionId, {
          loading: false,
          loadingSucceeded: true
        });
      } catch (e) {
        this.$set(this.syncProgress, filogixSubmissionId, {
          loading: false,
          loadingSucceeded: false
        });
      }
    }
  })
});